import { render, staticRenderFns } from "./GestioneSchedePalestraAdmin.vue?vue&type=template&id=38fb7bc8&"
import script from "./GestioneSchedePalestraAdmin.vue?vue&type=script&lang=js&"
export * from "./GestioneSchedePalestraAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports